module.exports = __webpack_public_path__ + "img/building-line.55c9fc00.svg";